import axios from 'axios'
import { getEnvVariable } from '@/helpers'
import extendAxiosInstance from './baseAxiosInstance'

const sigloNetAxiosInstance = axios.create({
  baseURL: getEnvVariable('VUE_APP_API_URL_SIGLO', process.env.VUE_APP_API_URL_SIGLO),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Tenant-Id': getEnvVariable(
      'VUE_APP_DEFAULT_TENANT',
      process.env.VUE_APP_DEFAULT_TENANT
    ),
  },
  timeout: getEnvVariable('TIME_ABORT_REQUEST', process.env.TIME_ABORT_REQUEST),
})

extendAxiosInstance(sigloNetAxiosInstance)

export default sigloNetAxiosInstance
